var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/defineProperty", "core-js/modules/es6.string.bold", "core-js/modules/es6.string.small", "./css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("core-js/modules/es6.string.bold"), require("core-js/modules/es6.string.small"), require("./css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.defineProperty, global.es6String, global.es6String, global.css);
    global.themes = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _defineProperty3, _es6String, _es6String2, _css) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var themes = {
    // default next theme
    next: {
      global: {
        borderColor: (0, _css.palette)('white'),
        mainBgColor: (0, _css.palette)('primary', 'mainBackground'),
        mainMenuBgColor: (0, _css.palette)('grey', 'menuDark'),
        mainSubMenuBgColor: (0, _css.palette)('primary', 'mainSubMenuBackground'),
        navBgColor: (0, _css.palette)('primary', 'mainNav'),
        dividerColor: (0, _css.palette)('primary', 'mainDivider'),
        textColor: (0, _css.palette)('white'),
        iconColor: 'white',
        msgColor: (0, _css.palette)('secondary', 'rgaaOrange')
      },
      singleLineSlider: {
        buttonBackgroundColor: 'transparent',
        arrowFillColor: 'white',
        arrowSizes: {
          default: 'xsmall',
          medium: 'medium'
        }
      },
      slider: {
        activeBulletColor: (0, _css.palette)('secondary', 'arteOrange'),
        gutter: {
          mobile: _css.columnGutter.small,
          desktop: _css.columnGutter.medium
        }
      },
      guide: {
        activeSlideColor: (0, _css.palette)('white'),
        activeSlideTextColor: (0, _css.palette)('primary', 'mainNav')
      },
      teaser: {
        bgColor: (0, _css.palette)('primary', 'mainNav'),
        shineColor: 'rgba(255, 255, 255, .025)',
        title: {
          format: 'oneline',
          font: {
            family: _css.font.family.body,
            weight: _css.font.weight.medium
          },
          lineHeight: 1.1,
          space: 5,
          textColor: (0, _css.palette)('white')
        }
      },
      footer: {
        titleBgColor: (0, _css.palette)('grey', 'xxDark')
      },
      logo: {
        headerColor: (0, _css.palette)('secondary', 'arteOrange'),
        mainColor: (0, _css.palette)('secondary', 'arteOrange')
      }
    },
    // club theme
    club: {
      global: {
        borderColor: (0, _css.palette)('white'),
        mainBgColor: (0, _css.palette)('primary', 'mainBackground'),
        mainMenuBgColor: (0, _css.palette)('grey', 'menuDark'),
        mainSubMenuBgColor: (0, _css.palette)('primary', 'mainSubMenuBackground'),
        navBgColor: (0, _css.palette)('primary', 'mainNav'),
        dividerColor: (0, _css.palette)('primary', 'mainDivider'),
        textColor: (0, _css.palette)('white'),
        iconColor: 'white',
        msgColor: (0, _css.palette)('green')
      },
      singleLineSlider: {
        buttonBackgroundColor: 'transparent',
        arrowFillColor: 'white',
        arrowSizes: {
          default: 'xsmall',
          medium: 'medium'
        }
      },
      slider: {
        activeBulletColor: (0, _css.palette)('secondary', 'arteOrange'),
        gutter: {
          mobile: _css.columnGutter.small,
          desktop: _css.columnGutter.medium
        }
      },
      guide: {
        activeSlideColor: (0, _css.palette)('white'),
        activeSlideTextColor: (0, _css.palette)('primary', 'mainNav')
      },
      teaser: {
        bgColor: (0, _css.palette)('primary', 'mainNav'),
        shineColor: 'rgba(255, 255, 255, .025)',
        title: {
          format: 'oneline',
          font: {
            family: _css.font.family.body,
            weight: _css.font.weight.medium
          },
          lineHeight: 1.1,
          space: 5,
          textColor: (0, _css.palette)('white')
        }
      },
      footer: {
        titleBgColor: (0, _css.palette)('grey', 'xxDark')
      },
      logo: {
        headerColor: (0, _css.palette)('secondary', 'arteOrange'),
        mainColor: (0, _css.palette)('secondary', 'arteOrange')
      }
    },
    // presse theme
    presse: {
      global: {
        borderColor: (0, _css.palette)('black'),
        mainBgColor: (0, _css.palette)('primary', 'mainBackground'),
        mainMenuBgColor: (0, _css.palette)('grey', 'menuDark'),
        mainSubMenuBgColor: (0, _css.palette)('primary', 'mainSubMenuBackground'),
        navBgColor: (0, _css.palette)('grey'),
        dividerColor: (0, _css.palette)('primary', 'mainDivider'),
        textColor: (0, _css.palette)('black'),
        iconColor: 'black',
        msgColor: (0, _css.palette)('secondary', 'rgaaOrange')
      },
      singleLineSlider: {
        buttonBackgroundColor: 'transparent',
        arrowFillColor: 'black',
        arrowSizes: {
          default: 'xsmall',
          medium: 'medium'
        }
      },
      slider: {
        activeBulletColor: (0, _css.palette)('secondary', 'arteOrange'),
        gutter: {
          mobile: _css.columnGutter.small,
          desktop: _css.columnGutter.medium
        }
      },
      guide: {
        activeSlideColor: (0, _css.palette)('primary', 'mainNav'),
        activeSlideTextColor: (0, _css.palette)('grey')
      },
      teaser: {
        bgColor: (0, _css.palette)('grey', 'lightDark'),
        shineColor: 'rgba(0, 0, 0, .05)',
        title: {
          format: 'oneline',
          font: {
            family: _css.font.family.body,
            weight: _css.font.weight.medium
          },
          lineHeight: 1.1,
          space: 5,
          textColor: (0, _css.palette)('black')
        }
      },
      footer: {
        titleBgColor: (0, _css.palette)('grey', 'xxDark')
      },
      logo: {
        headerColor: (0, _css.palette)('white'),
        mainColor: (0, _css.palette)('secondary', 'arteOrange')
      }
    },
    // corporate theme
    corporate: {
      global: {
        borderColor: (0, _css.palette)('black'),
        mainBgColor: (0, _css.palette)('primary', 'mainBackground'),
        mainMenuBgColor: (0, _css.palette)('grey', 'menuDark'),
        mainSubMenuBgColor: (0, _css.palette)('primary', 'mainSubMenuBackground'),
        navBgColor: (0, _css.palette)('grey'),
        dividerColor: (0, _css.palette)('primary', 'mainDivider'),
        textColor: (0, _css.palette)('black'),
        iconColor: 'black',
        msgColor: (0, _css.palette)('secondary', 'rgaaOrange')
      },
      singleLineSlider: {
        buttonBackgroundColor: 'transparent',
        arrowFillColor: 'black',
        arrowSizes: {
          default: 'xsmall',
          medium: 'medium'
        }
      },
      slider: {
        activeBulletColor: (0, _css.palette)('secondary', 'arteOrange'),
        gutter: {
          mobile: _css.columnGutter.small,
          desktop: _css.columnGutter.medium
        }
      },
      guide: {
        activeSlideColor: (0, _css.palette)('primary', 'mainNav'),
        activeSlideTextColor: (0, _css.palette)('grey')
      },
      teaser: {
        bgColor: (0, _css.palette)('grey', 'lightDark'),
        shineColor: 'rgba(0, 0, 0, .05)',
        title: {
          format: 'twolines',
          font: {
            family: _css.font.family.body,
            weight: _css.font.weight.bold
          },
          lineHeight: 1.2,
          space: 10,
          textColor: (0, _css.palette)('black')
        }
      },
      footer: {
        titleBgColor: (0, _css.palette)('grey', 'xxDark')
      },
      logo: {
        headerColor: (0, _css.palette)('white'),
        mainColor: (0, _css.palette)('secondary', 'arteOrange')
      }
    },
    // concert theme
    concert: {
      global: {
        borderColor: (0, _css.palette)('white'),
        mainBgColor: (0, _css.palette)('primary', 'mainBackground'),
        mainMenuBgColor: (0, _css.palette)('grey', 'menuDark'),
        mainSubMenuBgColor: (0, _css.palette)('primary', 'mainSubMenuBackground'),
        navBgColor: (0, _css.palette)('primary', 'mainNav'),
        dividerColor: (0, _css.palette)('primary', 'mainDivider'),
        textColor: (0, _css.palette)('white'),
        // !! do not use palette for svg icons !!
        iconColor: 'white',
        msgColor: (0, _css.palette)('secondary', 'rgaaOrange')
      },
      singleLineSlider: {
        buttonBackgroundColor: (0, _css.palette)('white'),
        arrowFillColor: 'black',
        arrowSizes: {
          default: 'xxsmall'
        }
      },
      slider: {
        activeBulletColor: (0, _css.palette)('pink', 'base'),
        gutter: {
          mobile: _css.columnGutter.small,
          desktop: _css.columnGutter.large
        }
      },
      guide: {
        activeSlideColor: (0, _css.palette)('white'),
        activeSlideTextColor: (0, _css.palette)('primary', 'mainNav')
      },
      teaser: {
        bgColor: (0, _css.palette)('primary', 'mainNav'),
        shineColor: 'rgba(255, 255, 255, .025)',
        title: {
          format: 'twolines',
          font: {
            family: _css.font.family.body,
            weight: _css.font.weight.bold
          },
          lineHeight: 1.2,
          space: 8,
          textColor: (0, _css.palette)('black')
        }
      },
      footer: {
        titleBgColor: (0, _css.palette)('grey', 'xxDark')
      },
      logo: {
        headerColor: (0, _css.palette)('secondary', 'arteOrange'),
        mainColor: (0, _css.palette)('pink', 'base')
      }
    }
  };
  themes.halfMast = _objectSpread(_objectSpread({}, themes.next), {}, {
    logo: {
      headerColor: (0, _css.palette)('black'),
      mainColor: (0, _css.palette)('black')
    }
  });
  var _default = themes;
  _exports.default = _default;
});